<template>
    <div class="modal fade" id="addCampaignPeopleModal" ref="addCampaignPeopleModal" tabindex="-1" role="dialog" aria-labelledby="addCampaignPeopleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12">
                            <h5 class="modal-title" id="addCampaignPeopleModalLabel">{{ $t('add_campaign_people.title') }}</h5>
                        </div>
                        <div class="col-12 mt-3">
                            <span class="note-text mx-auto mb-3">{{ $t('add_campaign_people.note') }}</span>
                        </div>
                        <div class="col-4 mt-2">
                            <span class="mb-3">{{ $t('add_campaign_people.campaign_secret') }}</span><br />
                            <span class="note-text weight-500 mb-3">{{ currentCampaignComputed.secret }}</span>
                        </div>
                        <div class="col-8 mt-2 float-right">
                            <span @click.prevent="copyToClipboardModal(currentCampaignComputed.secret)" class="edit-save-name mt-2 cursor-pointer">{{ $t('add_campaign_people.copy_secret') }}</span>
                            <div id="copy"></div>

                        </div>
                        <div class="col-4 mt-2">
                            <span class="mb-3 line-height-40">{{ $t('add_campaign_people.send_secret') }}</span><br />
                        </div>
                        <div class="col-8 mt-2 ml-0 pd-0 float-right">
                            <span class="mr-3"><a :href="'https://api.whatsapp.com/send?&text=' + shareText" target="_blank"><img width="40" height="40" src="./../../assets/whatsapp.png" alt="whatsapp" /></a></span>
                            <span class="mr-3"><a :href="'viber://forward?text=' + shareTextShort" target="_blank"><img width="40" height="40" src="./../../assets/viber.png" alt="viber" /></a></span>
                            <span><a :href="'mailto:?subject=&body=' + shareText" target="_blank"><img width="40" height="40" src="./../../assets/email.png" alt="email" /></a></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "AddCampaignPeopleModal",
        props: [],
        mixins: [HelperMixin],
        data() {
            return {
                
            }
        },
        created() {
                      
        },
        computed: {
            isMobile() {
                return this.detectMob();
            },

            shareText() {
                return this.$t('add_campaign_people.share_text', {url: window.location.origin, secret: this.currentCampaignComputed.secret});
            },
            
            shareTextShort() {
                return this.$t('add_campaign_people.share_text_short', {url: window.location.origin, secret: this.currentCampaignComputed.secret});
            },

            currentCampaignComputed() {
                return this.$store.getters["currentCampaign"];
            }
        },
        methods: {
            dismissDetails() {
                $('#addCampaignPeopleModal').modal('hide');
            },
        },
    };
</script>
